import gql from 'graphql-tag';

export const GET_FILTER_OPTIONS = gql`
  query FilterOptions($input: VOFilterOptionsInput!) {
    voFilterOptions(input: $input) {
      error
      success
      list {
        label
        value
        meta {
          color
          locationCategory
        }
      }
    }
  }
`;
